import React, { useEffect, useState, useContext } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as ProdutoAPI from '../../../api/produto';
import * as TabelaAPI from '../../../api/tabela';
import CRUDsAPI from '../../../api/CRUDs';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const CreateOrEdit = () => {
    const { empresaId, empresaIds } = getEmpresaScope();
    const [dados, setDados] = useState({
        empresaId: empresaId,
        ativo: true,
    });
    const [token] = useState(localStorage.getItem('token')) || '';
    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const pathname = '/MenuSub';
    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText');

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //enums e tabelas
    const [OptionsMenu, setOptionsMenu] = useState([]);
    const [OptionsOperacao, setOptionsOperacao] = useState([]);
    const [EnumNatureza, setEnumNatureza] = useState([]);

    //carregar API's Externas
    const consultaMenu = async () => {
        const result = await TabelaAPI.menu('');
        setOptionsMenu(result);
    };
    const consultaOperacao = async () => {
        const result = await ProdutoAPI.operacao();
        setOptionsOperacao(result);
    };

    //enums
    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);
        if (table === 'menuSubs') {
            if (field === 'natureza') {
                setEnumNatureza(result ? result : []);
            }
        }
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        consultaMenu();
        consultaOperacao();
        consultaEnum('menuSubs', 'natureza', null);
        if (uuid && uuid !== 'null') {
            //consulta a API
            CRUDsAPI.menuSub
                .consulta(uuid)
                .then((response) => {
                    setDados(response.data);
                })
                .catch((error) => {
                    console.error(error);
                    setFlashMessage(error.response.data.message, error.response.data.type);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, uuid]);

    async function managerDados(dados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CRUDsAPI.menuSub.editar(dados);
            } else {
                response = await CRUDsAPI.menuSub.cadastrar(dados);

                if (response.status === 202) {
                    setDados(response.data);
                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';
                    urlNavigate = pathname + '/CreateOrEdit';
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(() => {
                navigate(urlNavigate, params);
            }, parametro.msgTempo * 1000);
        } catch (error) {
            console.error(error);
            setFlashMessage(error.response.data.message, error.response.data.type);
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                empresaId={empresaId}
                empresaIds={empresaIds}
                parametro={parametro}
                handleSubmit={managerDados}
                btnText={btnText}
                OptionsMenu={OptionsMenu}
                OptionsOperacao={OptionsOperacao}
                OptionsNatureza={EnumNatureza}
                caminhoVoltar={pathname}
            />
        </section>
    );
};
export default CreateOrEdit;
